module.exports = __webpack_public_path__ + "static/media/app-store-icon-edited-2-reduced.43db5ab6.webp";